import Vue from 'vue';
import Vuex from 'vuex';
import activity from './activity';
import address from './address';
import auth from './auth';
import check from './check';
import createTeam from './createTeam';
import district from './district';
import error from './util/error';
import feedback from './feedback';
import framework from './framework';
import homePage from './homePage';
import monitor from './monitor';
import notify from './notify';
import rank from './rank';
import signIn from './signIn';
import user from './user';
import util from './util';
import team from './team';
import pay from './pay';
import equipment from './equipment';
import community from './community';
import invite from './invite';
import inviteTeam from './inviteTeam';
import participation from '@/modules/participation/store';
import shop from './shop';
import identification from './identification';
import market from './market';
import trainingPlan from './trainingPlan';
import badge from '@/modules/medal/store';
import wish from './wish';
import huangshan from './huangshan';
import wallet from './wallet';
import intraCity from './intraCity';
import plantTree from './plantTree';
import tesla from './tesla';
import inviteCard from '@/modules/activity/store/inviteCard';
import thirdPlat from './thirdPlat';
import participationCertificates from '@/modules/user/store/participationCertificates';
import triangle from '@/modules/triangle/store';
import dream from '@/modules/dream/store/index';
import game from '@/modules/game/store/index';
import number from './number';
import { m as rankV2 } from './rankv2';
import { m as lucky } from './lucky';
import { member } from './member';
import { packageStore } from './package';
import { deposit } from './deposit';
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    activity: activity,
    address: address,
    auth: auth,
    check: check,
    createTeam: createTeam,
    district: district,
    error: error,
    feedback: feedback,
    framework: framework,
    homePage: homePage,
    monitor: monitor,
    notify: notify,
    rank: rank,
    signIn: signIn,
    user: user,
    util: util,
    team: team,
    pay: pay,
    equipment: equipment,
    community: community,
    invite: invite,
    inviteTeam: inviteTeam,
    participation: participation,
    shop: shop,
    identification: identification,
    market: market,
    trainingPlan: trainingPlan,
    badge: badge,
    wish: wish,
    huangshan: huangshan,
    wallet: wallet,
    intraCity: intraCity,
    plantTree: plantTree,
    tesla: tesla,
    inviteCard: inviteCard,
    thirdPlat: thirdPlat,
    participationCertificates: participationCertificates,
    dream: dream,
    triangle: triangle,
    game: game,
    number: number,
    lucky: lucky,
    rankV2: rankV2,
    member: member,
    "package": packageStore,
    deposit: deposit
  }
});
export default store;